var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticStyle:{"height":"100%"}},[_c('header-template'),_c('router-view',{staticClass:"app-container"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }